import React from 'react';
import FavoriteOffers from '../FavoriteOffers';

const FavoritesPage = () => {
    return (
        <FavoriteOffers 
            apiEndpoint=""
            detailRouteBase="/consultant/job-detail"
            maxItems={20}
        />
    );
};

export default FavoritesPage;
